// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductListingPage_root__Lefz4"};